// extracted by mini-css-extract-plugin
export default {"upstreamContainer":"scopeDownstreamList_upstreamContainer__pL7XR","loaderAnimation":"scopeDownstreamList_loaderAnimation__JmASx"};